import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IDENTIDADE_API_URL } from '../services/crud-service/crud-base.service';
import { HEADER_REQUISICAO_SILENCIOSA } from '../services/error.interceptor';
import { ApiResult } from '../services/crud-service/response';
import { Tema } from './tema.model';

@Injectable({ providedIn: 'root' })
export class TemaDataService {
    private readonly url: string;

    constructor(
        @Inject(IDENTIDADE_API_URL) urlIdentidade: string,
        private httpClient: HttpClient
    ) {
        this.url = `${urlIdentidade}/v1/Usuario/Tema/Configuracao`;
    }

    // Falhas são tratadas pelo TemaService (mantém o tema local ou reverte), sem notificação global.
    private readonly headers = new HttpHeaders({ [HEADER_REQUISICAO_SILENCIOSA]: 'true' });

    public obter = () => this.httpClient.get<ApiResult<{ tema: Tema }>>(this.url, { headers: this.headers });

    public salvar = (tema: Tema) => this.httpClient.post<ApiResult<boolean>>(this.url, { tema }, { headers: this.headers });
}
